import { useEffect, useRef } from 'react';

/**
 * 開始前照会・ステージbundle読込を待つあいだ、背後のゲーム操作を止めるモーダル。
 * 取消や時間切れは持たず、状態が完了または失敗へ変わると App 側で閉じる。
 */
export function StagePreparationDialog() {
  const dialogRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const previousFocus =
      document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const appContent = document.querySelector<HTMLElement>('[data-app-content]');
    const previousInert = appContent?.inert ?? false;
    if (appContent) appContent.inert = true;
    dialogRef.current?.focus();

    // window の capture で止め、すでに登録済みの数字・Enter・矢印ショートカットにも届かせない。
    const blockKeys = (event: KeyboardEvent) => {
      // Cmd/Ctrl+R などのブラウザ操作は止めない。ただしゲーム側のショートカットへは渡さない。
      if (!event.metaKey && !event.ctrlKey && !event.altKey) event.preventDefault();
      event.stopImmediatePropagation();
    };
    window.addEventListener('keydown', blockKeys, true);

    return () => {
      window.removeEventListener('keydown', blockKeys, true);
      if (appContent) appContent.inert = previousInert;
      queueMicrotask(() => {
        if (previousFocus?.isConnected) previousFocus.focus();
      });
    };
  }, []);

  return (
    <div
      className="stage-preparation-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        // 背後クリックは backdrop が受け、フォーカスもモーダルから外さない。
        event.preventDefault();
        dialogRef.current?.focus();
      }}
    >
      <div
        ref={dialogRef}
        className="stage-preparation-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="stage-preparation-title"
        aria-describedby="stage-preparation-status"
        tabIndex={-1}
      >
        <h2 id="stage-preparation-title">ステージの じゅんび</h2>
        <p id="stage-preparation-status" role="status">
          ステージを じゅんびしてるよ…
        </p>
      </div>
    </div>
  );
}
